import * as React from 'react';
const DEFAULT_FILL = '#fff';

const Facebook = ({ fill = DEFAULT_FILL, size = 32 }) => {
  const isDefault = fill === DEFAULT_FILL;

  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none">
      {isDefault && <circle cx={16} cy={16} r={16} fill="#070243" />}
      <mask
        id="prefix__a"
        style={{
          maskType: 'alpha',
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={32}
        height={32}
      >
        {isDefault && <circle cx={16} cy={16} r={16} fill="#C4C4C4" />}
      </mask>
       <g mask={isDefault ? 'url(#prefix__a)' : undefined}>
       <path
          d="M32 16.084C32 7.204 24.833 0 16 0S0 7.204 0 16.084C0 24.126 5.833 30.827 13.5 32V20.775h-4v-4.691h4.167v-3.519c0-4.02 2.333-6.199 6-6.199 1.666 0 3.5.336 3.5.336v3.853h-2c-2 0-2.667 1.173-2.667 2.513v3.016H23l-.667 4.69h-3.666V32C26.167 30.827 32 24.126 32 16.084z"
          fill={fill}
        />
      </g>
    </svg>
  );
};

export default React.memo(Facebook);
